var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/core-js-pure/internals/well-known-symbol-wrapped.js
// module id = 382
// module chunks = 44